React = require 'react'
t = require('views/internal/recup-with-helpers')('org_filtering')
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'

module.exports = class extends React.Component
  displayName: 'BoardListItemTagAddComponent'
  render: t.renderable ->
    { onClick } = @props

    t.b onClick, class: 'board-tags-item mod-add', ->
      t.icon 'add',
        class: 'board-tags-item-icon'

  shouldComponentUpdate: naiveShouldComponentUpdate



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-tag-add-component.coffee